import { Pipe, PipeTransform } from '@angular/core';

// Interfaces
import { IMediaImageSize, IMediaDetails } from 'projects/models/src/public-api';

@Pipe({
    name: 'wpMediaSize',
})
export class WPMediaSize implements PipeTransform {

    public transform(value: IMediaDetails, ...args: any[]): string {
        if (value?.sizes) {
            if (args[0] != null) {
                return this.getSizeByName(value.sizes, args[0] as string).source_url;
            } else {
                const sizes: IMediaImageSize[] = this.sort(value.sizes);
                return sizes[0].source_url;
            }
        }
        else {
            return null;
        }
    }

    private getSizeByName(value: { [key: string]: IMediaImageSize }, name: string): IMediaImageSize {
        if (value[name] != null) {
            return value[name];
        }
        else {
            const sorted = this.sort(value);

            if (name === 'small') { return sorted[1]; }
            if (name === 'medium') { return sorted[sorted.length / 2]; }
            if (name === 'medium_large') { return sorted[sorted.length - 2]; }
            if (name === 'full') { return sorted[sorted.length - 1]; }

            return sorted[0];
        }
    }

    private sort(value: { [key: string]: IMediaImageSize }): IMediaImageSize[] {
        const sizes = new Array<IMediaImageSize>();

        for (const property in value) {
            if (value.hasOwnProperty(property)) {
                sizes.push(value[property]);
            }
        }

        return sizes.sort((a, b) => {
            if (a.width > b.width && a.height > b.height) { return 1; }
            if (a.width < b.width && a.height < b.height) { return -1; }
            return 0;
        });
    }

}
